<template>
    <div>
        <van-tabs v-model="active" title-active-color="rgba(33,150,243,1)">
            <van-tab title="消息" name="message">
                <message-list></message-list>
            </van-tab>
            <van-tab title="通讯录" name="contact">
                <van-empty description="暂无通讯录" />
            </van-tab>
        </van-tabs>
    </div>
</template>

<script>
import { Tab, Tabs, Empty } from 'vant';
import messageList from "./list.vue";
export default {
    components: {
        vanTab: Tab,
        vanTabs: Tabs,
        vanEmpty: Empty,
        messageList
    },
    data(){
        return {
            name: 'message',
            active:''
        }
    },
    mounted(){
    },
    methods:{
        goBack(){
            this.$router.go(-1)
        },
        logout(){
            clearLocalMessage();
            this.$router.push({path: '/login'})
        }
    }
}
</script>

<style>

</style>